import { Button, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui";
import { ModelResponse } from "@/types";
import { Pagination } from "../../pagination";
import { FormModels } from "../../forms/models/form-model";
import { DeleteModelDialog } from "../../forms/models/delete-model-dialog";

export function ModelDataTable({ data, perPage, handlePerPageChange }: {
  data: ModelResponse;
  perPage: number;
  handlePerPageChange: (perPage: number) => void;
}) {
  return <div className="space-y-4">
    <div className="overflow-hidden rounded-xl border border-app-border bg-app-surface">
      <Table><TableHeader><TableRow><TableHead>Modelo</TableHead><TableHead>Tipo de contrato</TableHead><TableHead className="text-right">Ações</TableHead></TableRow></TableHeader>
        <TableBody>{data.items.map(model => <TableRow key={model.id}>
          <TableCell className="min-w-48 font-medium text-app-fg-strong">{model.description}</TableCell>
          <TableCell><span className="rounded-full bg-app-surface-muted px-3 py-1 text-sm">{model.modelType.name}</span></TableCell>
          <TableCell><div className="flex justify-end gap-1"><FormModels model={model}><Button type="button" variant="outline" aria-label={`Editar ${model.description}`}>Editar</Button></FormModels><DeleteModelDialog id={model.id} name={model.description} /></div></TableCell>
        </TableRow>)}</TableBody>
      </Table>
    </div>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <label className="flex items-center gap-2 text-sm text-app-fg-muted">Modelos por página<select aria-label="Modelos por página" value={perPage} onChange={event => handlePerPageChange(Number(event.target.value))} className="h-10 rounded-md border border-app-border bg-app-surface px-3 text-app-fg focus:ring-2 focus:ring-brand">{[10, 25, 50, 100].map(size => <option key={size}>{size}</option>)}</select></label>
      <Pagination data={data.data} />
    </div>
  </div>;
}
